<app-button [color]="color" [disabled]="disabled" [fullWidth]="fullWidth" [icon]="icon" [label]="label"
            classButton="my-primary-button" raised></app-button>
